import { render } from "./BasicInfo.vue?vue&type=template&id=45d5375e&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"

import "./BasicInfo.vue?vue&type=style&index=0&id=45d5375e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d5375e"]])

export default __exports__